module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.5863/images/default-avatar.png"